/**
* In this file contains the Vaccination UI screen and logic
**/
import { Modal,Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import ApiService from './../../services/ApiService';
import { postAnalytics } from './../../services/ReusabilityService';
import Vacccination from './../components/Vaccination';
import { useTranslation } from 'react-i18next';

/**
 * @props pass the data and handleClose call back events
 * @data pass the member id ,parent id and vaccination in Object format
 **/
function VaccinationModal(props) {
	
	/**
	 * Intial state declaration
	 **/
	const [data,setData]=useState([]);	
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();
	//Component initialize function	
	useEffect(()=>{
		
			(async()=>{			
				var response = await ApiService.getMemberVaccination({id:props.data.member});
				if(response.status===200){
				 setData(response.data.items);	
				 sessionStorage.setItem('screenStartTime', new Date());
				}
			})();
			
		//To post the Analytics data
		return async()=>{
			var reqData={};
			reqData.parent = props.data.parent;
			reqData.member = props.data.member;
			reqData.module = 'vaccination';
			postAnalytics(reqData);
		}
	},[props]);
	
  return (
  <Modal 
	show={props.data.vaccination} 
	onHide={props.handleClose}  
	backdrop="static"
    keyboard={false}
	size="xl"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
        <Modal.Title className="text-capitalize">{props.data?.name}{t('common.possessive_suffix')} {t('sidebar.vaccination')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
	  {/*Import Vacccination*/}
	    <Vacccination dob={props?.data?.dob} data={data}/>

	  </Modal.Body>
	  {/*Footer*/}
	  <Modal.Footer>
	   <Button variant="secondary" className={`btn btn-sm ${role===4?'btn-tmAquaGreen':'btn-tmPink'}`} onClick={props.handleClose}>
          {t('modal.close')}
        </Button>
	  </Modal.Footer>
	</Modal>
  );
}

export default VaccinationModal;
